export const itemsContainer = ({ items }) => items;
